import { createSlice } from "@reduxjs/toolkit";

const initialLegalReportState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  exportStatus: null,
  rapReportExportStatus: null,
  ldrReportExportStatus: null,
  invenAdjustReportExportStatus: null,
  kctReportExportStatus: null, // Kentucky Cigarette Tax Report status
  indianaCigReportExportStatus: null,
  georgiaTaxReportExportStatus: null,
  tennesseeTaxReportExportStatus: null,
  rapReportExportUrl: null,
  ldrReportExportUrl: null,
  invenAdjustReportExportUrl: null,
  kctReportExportUrl: null, // Kentucky Cigarette Tax Report URL
  indianaCigReportExportUrl: null,
  georgiaTaxReportExportUrl: null,
  tennesseeTaxReportExportUrl: null,
  message: {
    error: null,
    success: null,
    modalError: null,
    modalSuccess: null,
  },
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const legalReportSlice = createSlice({
  name: "legalReport",
  initialState: initialLegalReportState,
  reducers: {
    updateRapReportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.rapReportExportStatus = status;
      state.rapReportExportUrl = url;
    },
    updateLdrReportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.ldrReportExportStatus = status;
      state.ldrReportExportUrl = url;
    },
    updateInvenAdjustReportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.invenAdjustReportExportStatus = status;
      state.invenAdjustReportExportUrl = url;
    },
    updateKctReportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.kctReportExportStatus = status;
      state.kctReportExportUrl = url;
    },
    updateIndianaCigReportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.indianaCigReportExportStatus = status;
      state.indianaCigReportExportUrl = url;
    },
    updateGeorgiaTaxReportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.georgiaTaxReportExportStatus = status;
      state.georgiaTaxReportExportUrl = url;
    },
    updateTennesseeTaxReportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.tennesseeTaxReportExportStatus = status;
      state.tennesseeTaxReportExportUrl = url;
    },
  },
});
